import { LLableValue } from "@components/LLabelValue";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getAgeFromBirthdate } from "@helpers/examineeHelper";
import { ExistingExamineeDetails } from "@store/generalTypes";
import { format, parseISO } from "date-fns";
import { useState } from "react";
import { Translate, translate } from "react-i18nify";

export const AssessmentMoreDetails = (examinee: ExistingExamineeDetails): JSX.Element => {
    const [showDetails, setShowDetails] = useState(false);

    return (
        <>
            <div
                className="is-clickable py-2"
                onClick={() => setShowDetails(!showDetails)}
                data-html2canvas-ignore="true"
            >
                {!showDetails && (
                    <span className="has-text-weight-bold has-text-primary pr-2">
                        <Translate value="admin.examineeDetails" />{" "}
                        <FontAwesomeIcon className="pl-2" icon={faCaretDown} />
                    </span>
                )}
                {showDetails && (
                    <span className="has-text-weight-bold has-text-primary pr-2">
                        <Translate value="admin.examineeDetails" />{" "}
                        <FontAwesomeIcon className="pl-2" icon={faCaretUp} />
                    </span>
                )}
            </div>
            {showDetails && (
                <div className="columns is-multiline">
                    <div className="column is-one-quarter">
                        <LLableValue
                            label={translate("admin.age")}
                            value={
                                // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                                getAgeFromBirthdate(examinee.birthDate).toString() +
                                " - " +
                                format(parseISO(examinee.birthDate), "MMM dd, yyyy")
                            }
                        />
                    </div>
                    <div className="column is-one-quarter">
                        <LLableValue label={translate("admin.sex")} value={translate(`admin.${examinee.sex}`)} />
                    </div>
                    <div className="column is-one-quarter">
                        <LLableValue
                            label={translate("admin.race")}
                            value={translate(`admin.${examinee.race}`) ?? translate("admin.notSpecified")}
                        />
                    </div>
                    <div className="column is-one-quarter">
                        <LLableValue
                            label={translate("admin.ethnicity")}
                            value={translate(`admin.${examinee.ethnicity}`) ?? translate("admin.notSpecified")}
                        />
                    </div>
                    <div className="column is-one-quarter">
                        <LLableValue
                            label={translate("admin.highestLevelEducation")}
                            value={examinee.highestLevelEducation}
                        />
                    </div>
                    <div className="column is-one-quarter">
                        <LLableValue label={translate("admin.primaryLanguage")} value={examinee.primaryLanguage} />
                    </div>
                    <div className="column is-one-quarter">
                        <LLableValue
                            label={translate("admin.secondaryLanguages")}
                            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                            value={examinee.secondaryLanguages?.join(", ") || translate("admin.notSpecified")}
                        />
                    </div>
                </div>
            )}
        </>
    );
};
